import { DocumentData } from "@king-ict/eupisi-ui/models";

import { OtherLegalEntityLocation, ExecutionResolutionDocument, ProgramRequestStatusHistory, Competence, OtherLocation } from ".";
import { AdditionalDocumentation } from "./AdditionalDocumentation";
import { Envelope } from "./Envelope";
import { Module } from "./Module";
import { ProgramRequestTeacher } from "./ProgramRequestTeacher";


export interface ProgramRequestDetailBase {
  id: number;
  stateId: number;
  programId?: number;
  programName: string;
  guidedLearningDuration: number;
  independentLearningDuration: number;
  workLearningDuration: number;
  hkoLevelId: number | null;
  qualificationTypeId?: number;
  educationSectorId?: number;
  educationSubSectorId?: number;
  languageLevelBusinessIds: number[];
  languageLevelGeneralIds: number[];
  formOfTeachingIds: number[];
  knowledgeChecksIds: number[];
  enrollmentConditionsIds: number[];
};

/** maps to a NewProgramRequestDetailDto */
export interface ProgramRequestDetail extends ProgramRequestDetailBase {
  programCode: string;
  hkoLevel: string;
  qualificationType: string;
  educationSector: string;
  educationSubSector: string;
  profession?: string;
  qualification?: string;
  formOfTeaching: string[];
  otherFormsOfTeaching: string[];
  otherFormsOfTeachingIds: number[];
  knowledgeChecks: string[];
  otherKnowledgeChecks: string[];
  otherKnowledgeChecksIds: number[];
  enrollmentConditions: string[];
  otherEnrollmentConditions: string[];
  otherEnrollmentConditionsIds: number[];
  locationHeadquarter: boolean;
  outsideHeadquarter: boolean;
  outsideHeadquarterIds: number[];
  locationOtherLegalEntity: boolean;
  remark: string;
  remarkInstitution: string;
  curriculumProgramDocumentId: number;
  programLanguage: string;
  languageLevelBusiness: string[];
  languageLevelGeneral: string[];
  curriculumProgramDocument?: DocumentData;
  otherLegalEntityLocations: OtherLegalEntityLocation[];
  competences: Competence[];
  modules: Module[];
  programRequestTeachers: ProgramRequestTeacher[];
  envelope?: Envelope;  
  additionalDocumentation: AdditionalDocumentation[];
  otherLocations: OtherLocation[];
  isCurrent: boolean;
  isAutomaticallySubmitted: boolean;
}

export const createProgramRequestDetailInitial = (): ProgramRequestDetail => {
  return {
    id: 0,
    stateId: 1,
    programName: "",
    programCode: "",
    hkoLevelId: 0,
    hkoLevel: "",
    qualificationType: "",
    educationSector: "",
    educationSubSector: "",
    guidedLearningDuration: 0,
    independentLearningDuration: 0,
    workLearningDuration: 0,
    formOfTeaching: [],
    formOfTeachingIds: [],
    otherFormsOfTeaching: [],
    otherFormsOfTeachingIds: [],
    knowledgeChecks: [],
    knowledgeChecksIds: [],
    otherKnowledgeChecks: [],
    otherKnowledgeChecksIds: [],
    enrollmentConditions: [],
    enrollmentConditionsIds: [],
    otherEnrollmentConditions: [],
    otherEnrollmentConditionsIds: [],
    locationHeadquarter: false,
    outsideHeadquarter: false,
    outsideHeadquarterIds: [],
    locationOtherLegalEntity: false,
    remark: "",
    remarkInstitution: "",
    curriculumProgramDocumentId: 0,
    programLanguage: "",
    languageLevelBusiness: [],
    languageLevelBusinessIds: [],
    languageLevelGeneral: [],
    languageLevelGeneralIds: [],
    otherLegalEntityLocations: [],
    competences: [],
    modules: [],
    programRequestTeachers: [],
    additionalDocumentation: [],
    otherLocations: [],
    isCurrent: false,
    isAutomaticallySubmitted: false
  };
}